<template lang="pug">
.pdf-modal
  b-modal(v-model="_value" :size="size" no-close-on-backdrop no-close-on-esc hide-footer)
    .default-modal-body(v-if="_value").text-center
      img.image(:src="imageUrl")
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### 画像プレビューモーダル
 */
@Component
export default class ImageModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** モーダルサイズ */
  @Prop({ default: () => "xl" })
  size!: string;
  /** 表示する画像のURL。S3格納の場合は先に公開URLにしておく必要がある */
  @Prop()
  imageUrl!: string;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }
}
</script>

<style lang="scss" scoped>
.default-modal-body {
  height: 83vh;

  .image {
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
